<template>
  <Rate
    v-model="info.defaultValue"
    :count="info.form.count"
    :allow-half="info.form.allowHalf"
    :show-text="info.form.showText"
    :disabled="info.form.disabled||!info.isNew" />
</template>
<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseRate',
  mixins: [ baseComponentMixins ],
}
</script>